/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ShopifyDeliveryDefaults } from "./ShopifyDeliveryDefaults";
import {
  ShopifyDeliveryDefaultsFromJSON,
  ShopifyDeliveryDefaultsFromJSONTyped,
  ShopifyDeliveryDefaultsToJSON,
  ShopifyDeliveryDefaultsToJSONTyped,
} from "./ShopifyDeliveryDefaults";
import type { ShopifyPalletizationConfig } from "./ShopifyPalletizationConfig";
import {
  ShopifyPalletizationConfigFromJSON,
  ShopifyPalletizationConfigFromJSONTyped,
  ShopifyPalletizationConfigToJSON,
  ShopifyPalletizationConfigToJSONTyped,
} from "./ShopifyPalletizationConfig";
import type { CheckoutMarkup } from "./CheckoutMarkup";
import {
  CheckoutMarkupFromJSON,
  CheckoutMarkupFromJSONTyped,
  CheckoutMarkupToJSON,
  CheckoutMarkupToJSONTyped,
} from "./CheckoutMarkup";
import type { ShopifyDimensionMetafieldMapping } from "./ShopifyDimensionMetafieldMapping";
import {
  ShopifyDimensionMetafieldMappingFromJSON,
  ShopifyDimensionMetafieldMappingFromJSONTyped,
  ShopifyDimensionMetafieldMappingToJSON,
  ShopifyDimensionMetafieldMappingToJSONTyped,
} from "./ShopifyDimensionMetafieldMapping";
import type { ShopifyTagAccessorialRule } from "./ShopifyTagAccessorialRule";
import {
  ShopifyTagAccessorialRuleFromJSON,
  ShopifyTagAccessorialRuleFromJSONTyped,
  ShopifyTagAccessorialRuleToJSON,
  ShopifyTagAccessorialRuleToJSONTyped,
} from "./ShopifyTagAccessorialRule";
import type { ShopifyTagLocationTypeRule } from "./ShopifyTagLocationTypeRule";
import {
  ShopifyTagLocationTypeRuleFromJSON,
  ShopifyTagLocationTypeRuleFromJSONTyped,
  ShopifyTagLocationTypeRuleToJSON,
  ShopifyTagLocationTypeRuleToJSONTyped,
} from "./ShopifyTagLocationTypeRule";
import type { ShopifyHandlingTimeMetafieldMapping } from "./ShopifyHandlingTimeMetafieldMapping";
import {
  ShopifyHandlingTimeMetafieldMappingFromJSON,
  ShopifyHandlingTimeMetafieldMappingFromJSONTyped,
  ShopifyHandlingTimeMetafieldMappingToJSON,
  ShopifyHandlingTimeMetafieldMappingToJSONTyped,
} from "./ShopifyHandlingTimeMetafieldMapping";
import type { CheckoutRateSelector } from "./CheckoutRateSelector";
import {
  CheckoutRateSelectorFromJSON,
  CheckoutRateSelectorFromJSONTyped,
  CheckoutRateSelectorToJSON,
  CheckoutRateSelectorToJSONTyped,
} from "./CheckoutRateSelector";
import type { ShopifyPickupLocation } from "./ShopifyPickupLocation";
import {
  ShopifyPickupLocationFromJSON,
  ShopifyPickupLocationFromJSONTyped,
  ShopifyPickupLocationToJSON,
  ShopifyPickupLocationToJSONTyped,
} from "./ShopifyPickupLocation";
import type { ShopifyOriginConfig } from "./ShopifyOriginConfig";
import {
  ShopifyOriginConfigFromJSON,
  ShopifyOriginConfigFromJSONTyped,
  ShopifyOriginConfigToJSON,
  ShopifyOriginConfigToJSONTyped,
} from "./ShopifyOriginConfig";

/**
 *
 * @export
 * @interface ShopifyConfig
 */
export interface ShopifyConfig {
  /**
   *
   * @type {string}
   * @memberof ShopifyConfig
   */
  shopDomain?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyConfig
   */
  rateCallbackSecret?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyConfig
   */
  carrierServiceGid?: string | null;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof ShopifyConfig
   */
  webhookSubscriptionGids: { [key: string]: string };
  /**
   *
   * @type {ShopifyOriginConfig}
   * @memberof ShopifyConfig
   */
  origin?: ShopifyOriginConfig | null;
  /**
   *
   * @type {number}
   * @memberof ShopifyConfig
   */
  handlingTimeBusinessDays: number;
  /**
   *
   * @type {ShopifyDeliveryDefaults}
   * @memberof ShopifyConfig
   */
  deliveryDefaults: ShopifyDeliveryDefaults;
  /**
   *
   * @type {string}
   * @memberof ShopifyConfig
   */
  pickupLocationType: string;
  /**
   *
   * @type {string}
   * @memberof ShopifyConfig
   */
  pickupDistributionWarehouseBrand?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ShopifyConfig
   */
  pickupAccessorials: Array<string>;
  /**
   *
   * @type {Array<ShopifyPickupLocation>}
   * @memberof ShopifyConfig
   */
  pickupLocations: Array<ShopifyPickupLocation>;
  /**
   *
   * @type {Array<string>}
   * @memberof ShopifyConfig
   */
  allowedCarriers: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ShopifyConfig
   */
  blockedCarriers: Array<string>;
  /**
   *
   * @type {number}
   * @memberof ShopifyConfig
   */
  maxHandlingUnits: number;
  /**
   *
   * @type {CheckoutMarkup}
   * @memberof ShopifyConfig
   */
  markup: CheckoutMarkup;
  /**
   *
   * @type {number}
   * @memberof ShopifyConfig
   */
  maxRatesPerResponse: number;
  /**
   *
   * @type {Array<CheckoutRateSelector>}
   * @memberof ShopifyConfig
   */
  rateSelectors: Array<CheckoutRateSelector>;
  /**
   *
   * @type {ShopifyDimensionMetafieldMapping}
   * @memberof ShopifyConfig
   */
  dimensionMetafields?: ShopifyDimensionMetafieldMapping | null;
  /**
   *
   * @type {ShopifyHandlingTimeMetafieldMapping}
   * @memberof ShopifyConfig
   */
  handlingTimeMetafield?: ShopifyHandlingTimeMetafieldMapping | null;
  /**
   *
   * @type {ShopifyPalletizationConfig}
   * @memberof ShopifyConfig
   */
  palletization: ShopifyPalletizationConfig;
  /**
   *
   * @type {boolean}
   * @memberof ShopifyConfig
   */
  ratesEnabled: boolean;
  /**
   *
   * @type {Array<ShopifyTagAccessorialRule>}
   * @memberof ShopifyConfig
   */
  tagAccessorialRules: Array<ShopifyTagAccessorialRule>;
  /**
   *
   * @type {Array<ShopifyTagLocationTypeRule>}
   * @memberof ShopifyConfig
   */
  tagLocationTypeRules: Array<ShopifyTagLocationTypeRule>;
  /**
   *
   * @type {Array<string>}
   * @memberof ShopifyConfig
   */
  requiredCustomerTags?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ShopifyConfig
   */
  excludedProductTags: Array<string>;
}

/**
 * Check if a given object implements the ShopifyConfig interface.
 */
export function instanceOfShopifyConfig(value: object): value is ShopifyConfig {
  if (
    !("webhookSubscriptionGids" in value) ||
    value["webhookSubscriptionGids"] === undefined
  )
    return false;
  if (
    !("handlingTimeBusinessDays" in value) ||
    value["handlingTimeBusinessDays"] === undefined
  )
    return false;
  if (!("deliveryDefaults" in value) || value["deliveryDefaults"] === undefined)
    return false;
  if (
    !("pickupLocationType" in value) ||
    value["pickupLocationType"] === undefined
  )
    return false;
  if (
    !("pickupAccessorials" in value) ||
    value["pickupAccessorials"] === undefined
  )
    return false;
  if (!("pickupLocations" in value) || value["pickupLocations"] === undefined)
    return false;
  if (!("allowedCarriers" in value) || value["allowedCarriers"] === undefined)
    return false;
  if (!("blockedCarriers" in value) || value["blockedCarriers"] === undefined)
    return false;
  if (!("maxHandlingUnits" in value) || value["maxHandlingUnits"] === undefined)
    return false;
  if (!("markup" in value) || value["markup"] === undefined) return false;
  if (
    !("maxRatesPerResponse" in value) ||
    value["maxRatesPerResponse"] === undefined
  )
    return false;
  if (!("rateSelectors" in value) || value["rateSelectors"] === undefined)
    return false;
  if (!("palletization" in value) || value["palletization"] === undefined)
    return false;
  if (!("ratesEnabled" in value) || value["ratesEnabled"] === undefined)
    return false;
  if (
    !("tagAccessorialRules" in value) ||
    value["tagAccessorialRules"] === undefined
  )
    return false;
  if (
    !("tagLocationTypeRules" in value) ||
    value["tagLocationTypeRules"] === undefined
  )
    return false;
  if (
    !("excludedProductTags" in value) ||
    value["excludedProductTags"] === undefined
  )
    return false;
  return true;
}

export function ShopifyConfigFromJSON(json: any): ShopifyConfig {
  return ShopifyConfigFromJSONTyped(json, false);
}

export function ShopifyConfigFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShopifyConfig {
  if (json == null) {
    return json;
  }
  return {
    shopDomain: json["shopDomain"] == null ? undefined : json["shopDomain"],
    rateCallbackSecret:
      json["rateCallbackSecret"] == null
        ? undefined
        : json["rateCallbackSecret"],
    carrierServiceGid:
      json["carrierServiceGid"] == null ? undefined : json["carrierServiceGid"],
    webhookSubscriptionGids: json["webhookSubscriptionGids"],
    origin:
      json["origin"] == null
        ? undefined
        : ShopifyOriginConfigFromJSON(json["origin"]),
    handlingTimeBusinessDays: json["handlingTimeBusinessDays"],
    deliveryDefaults: ShopifyDeliveryDefaultsFromJSON(json["deliveryDefaults"]),
    pickupLocationType: json["pickupLocationType"],
    pickupDistributionWarehouseBrand:
      json["pickupDistributionWarehouseBrand"] == null
        ? undefined
        : json["pickupDistributionWarehouseBrand"],
    pickupAccessorials: json["pickupAccessorials"],
    pickupLocations: (json["pickupLocations"] as Array<any>).map(
      ShopifyPickupLocationFromJSON,
    ),
    allowedCarriers: json["allowedCarriers"],
    blockedCarriers: json["blockedCarriers"],
    maxHandlingUnits: json["maxHandlingUnits"],
    markup: CheckoutMarkupFromJSON(json["markup"]),
    maxRatesPerResponse: json["maxRatesPerResponse"],
    rateSelectors: (json["rateSelectors"] as Array<any>).map(
      CheckoutRateSelectorFromJSON,
    ),
    dimensionMetafields:
      json["dimensionMetafields"] == null
        ? undefined
        : ShopifyDimensionMetafieldMappingFromJSON(json["dimensionMetafields"]),
    handlingTimeMetafield:
      json["handlingTimeMetafield"] == null
        ? undefined
        : ShopifyHandlingTimeMetafieldMappingFromJSON(
            json["handlingTimeMetafield"],
          ),
    palletization: ShopifyPalletizationConfigFromJSON(json["palletization"]),
    ratesEnabled: json["ratesEnabled"],
    tagAccessorialRules: (json["tagAccessorialRules"] as Array<any>).map(
      ShopifyTagAccessorialRuleFromJSON,
    ),
    tagLocationTypeRules: (json["tagLocationTypeRules"] as Array<any>).map(
      ShopifyTagLocationTypeRuleFromJSON,
    ),
    requiredCustomerTags:
      json["requiredCustomerTags"] == null
        ? undefined
        : json["requiredCustomerTags"],
    excludedProductTags: json["excludedProductTags"],
  };
}

export function ShopifyConfigToJSON(json: any): ShopifyConfig {
  return ShopifyConfigToJSONTyped(json, false);
}

export function ShopifyConfigToJSONTyped(
  value?: ShopifyConfig | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shopDomain: value["shopDomain"],
    rateCallbackSecret: value["rateCallbackSecret"],
    carrierServiceGid: value["carrierServiceGid"],
    webhookSubscriptionGids: value["webhookSubscriptionGids"],
    origin: ShopifyOriginConfigToJSON(value["origin"]),
    handlingTimeBusinessDays: value["handlingTimeBusinessDays"],
    deliveryDefaults: ShopifyDeliveryDefaultsToJSON(value["deliveryDefaults"]),
    pickupLocationType: value["pickupLocationType"],
    pickupDistributionWarehouseBrand: value["pickupDistributionWarehouseBrand"],
    pickupAccessorials: value["pickupAccessorials"],
    pickupLocations: (value["pickupLocations"] as Array<any>).map(
      ShopifyPickupLocationToJSON,
    ),
    allowedCarriers: value["allowedCarriers"],
    blockedCarriers: value["blockedCarriers"],
    maxHandlingUnits: value["maxHandlingUnits"],
    markup: CheckoutMarkupToJSON(value["markup"]),
    maxRatesPerResponse: value["maxRatesPerResponse"],
    rateSelectors: (value["rateSelectors"] as Array<any>).map(
      CheckoutRateSelectorToJSON,
    ),
    dimensionMetafields: ShopifyDimensionMetafieldMappingToJSON(
      value["dimensionMetafields"],
    ),
    handlingTimeMetafield: ShopifyHandlingTimeMetafieldMappingToJSON(
      value["handlingTimeMetafield"],
    ),
    palletization: ShopifyPalletizationConfigToJSON(value["palletization"]),
    ratesEnabled: value["ratesEnabled"],
    tagAccessorialRules: (value["tagAccessorialRules"] as Array<any>).map(
      ShopifyTagAccessorialRuleToJSON,
    ),
    tagLocationTypeRules: (value["tagLocationTypeRules"] as Array<any>).map(
      ShopifyTagLocationTypeRuleToJSON,
    ),
    requiredCustomerTags: value["requiredCustomerTags"],
    excludedProductTags: value["excludedProductTags"],
  };
}
